(() => {
  const button = document.querySelector('.rwady-whatsapp-float');
  if (!button || button.dataset.draggableReady) return;
  button.dataset.draggableReady = 'true';
  const key = 'rwady-whatsapp-position-v2';
  let position = null;
  let gesture = null;
  let lastDrag = 0;
  const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
  const bounds = () => {
    const rect = button.getBoundingClientRect();
    const viewport = window.visualViewport;
    const width = viewport?.width || window.innerWidth;
    const height = viewport?.height || window.innerHeight;
    const left = viewport?.offsetLeft || 0;
    const top = viewport?.offsetTop || 0;
    const mobile = window.innerWidth <= 767;
    const tablet = window.innerWidth >= 768 && window.innerWidth <= 1023;
    const bottomSpace = mobile ? 100 : tablet ? 92 : 24;
    const safeBottom = parseFloat(getComputedStyle(button).getPropertyValue('--wa-safe-bottom')) || 0;
    const minX = left + 12;
    const y = Math.max(top + 12, top + height - rect.height - bottomSpace - safeBottom);
    // On phones dragging stays within a lower band above the navigation.
    return { minX, minY: mobile ? Math.max(top + 12, y - 140) : top + 12,
      x: Math.max(minX, left + width - rect.width - 12), y };
  };
  const place = (x, y) => {
    const max = bounds();
    const left = clamp(x, max.minX, max.x);
    const top = clamp(y, max.minY, max.y);
    button.style.insetInlineStart = 'auto';
    button.style.right = 'auto';
    button.style.bottom = 'auto';
    button.style.left = left + 'px';
    button.style.top = top + 'px';
    position = { x: (left - max.minX) / Math.max(1, max.x - max.minX),
      y: (top - max.minY) / Math.max(1, max.y - max.minY) };
  };
  const restore = () => {
    const max = bounds();
    if (!position) {
      const rect = button.getBoundingClientRect();
      place(rect.left, max.y);
      return;
    }
    place(max.minX + position.x * (max.x - max.minX), max.minY + position.y * (max.y - max.minY));
  };
  try {
    const saved = JSON.parse(localStorage.getItem(key));
    if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
      position = { x: clamp(saved.x, 0, 1), y: clamp(saved.y, 0, 1) };
      restore();
    }
  } catch (_) {}
  button.addEventListener('pointerdown', (event) => {
    if (!event.isPrimary || event.button !== 0) return;
    const rect = button.getBoundingClientRect();
    gesture = { id: event.pointerId, startX: event.clientX, startY: event.clientY,
      left: rect.left, top: rect.top, dragging: false };
    button.setPointerCapture(event.pointerId);
  });
  button.addEventListener('pointermove', (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    const dx = event.clientX - gesture.startX;
    const dy = event.clientY - gesture.startY;
    if (!gesture.dragging && Math.hypot(dx, dy) < 7) return;
    gesture.dragging = true;
    button.classList.add('is-dragging');
    event.preventDefault();
    place(gesture.left + dx, gesture.top + dy);
  });
  const finish = (event) => {
    if (!gesture || event.pointerId !== gesture.id) return;
    if (gesture.dragging) {
      lastDrag = Date.now();
      try { localStorage.setItem(key, JSON.stringify(position)); } catch (_) {}
    }
    gesture = null;
    button.classList.remove('is-dragging');
    if (button.hasPointerCapture(event.pointerId)) button.releasePointerCapture(event.pointerId);
  };
  button.addEventListener('pointerup', finish);
  button.addEventListener('pointercancel', finish);
  button.addEventListener('lostpointercapture', finish);
  button.addEventListener('click', (event) => {
    if (event.detail !== 0 && Date.now() - lastDrag < 500) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  button.addEventListener('dragstart', (event) => event.preventDefault());
  let queued = false;
  const scheduleRestore = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; restore(); });
  };
  window.addEventListener('resize', scheduleRestore);
  window.addEventListener('pageshow', scheduleRestore);
  window.visualViewport?.addEventListener('resize', scheduleRestore);
  window.visualViewport?.addEventListener('scroll', scheduleRestore);
  restore();
})();
